import elClasico from "../assets/sports/el-clasico.webp";
import championsLeague2526 from "../assets/sports/champions-league-2526.webp";
import laligaDazn from "../assets/sports/laliga-dazn.webp";
import afcon25 from "../assets/sports/afcon25.webp";
import eredivisie from "../assets/sports/eredivisie.webp";
import bundesligaStars from "../assets/sports/bundesliga-stars.webp";
import premierLeague2526 from "../assets/sports/premier-league-2526.webp";
import serieA2526 from "../assets/sports/serie-a-2526.webp";
import euro2024Champions from "../assets/sports/euro-2024-champions.webp";
import laligaStars from "../assets/sports/laliga-stars.webp";
import championsLeagueTrophy from "../assets/sports/champions-league-trophy.webp";
import motogp from "../assets/sports/motogp.jpg";
import ufcPoster from "../assets/sports/ufc.jpg";

import leag1 from "../assets/league/Ligue_1.png";
import leag2 from "../assets/league/Ligue_2.png";
import leag3 from "../assets/league/Champions_League.svg";
import leag4 from "../assets/league/Premier_League_new.svg";
import leag5 from "../assets/league/LaLiga_new.svg";
import leag6 from "../assets/league/Serie_A_new.svg";
import leag7 from "../assets/league/Bundesliga_new.svg";
import leag8 from "../assets/league/Jupiler_Pro_League.png";
import leag9 from "../assets/league/Europa_League_new.svg";
import leag10 from "../assets/league/rsl.png";
import leag11 from "../assets/league/UFC.png";
import leag12 from "../assets/league/F1_new.svg";
import leag13 from "../assets/league/Copa_del_Rey.svg";

import SectionHeading from '../components/SectionHeading';
import Marquee from '../components/Marquee';
import Reveal from '../components/Reveal';
import { useLanguage } from '../i18n/LanguageContext';
import { sportsContent } from '../i18n/content/sports';

export default function Sports() {
  const { lang } = useLanguage();
  const c = sportsContent[lang];
  const sports = [
    { id: 1, image: elClasico, title: "El Clásico" },
    { id: 2, image: championsLeague2526, title: "Champions League 2025/26" },
    { id: 3, image: laligaDazn, title: "LaLiga" },
    { id: 4, image: afcon25, title: "AFCON Marruecos 2025" },
    { id: 5, image: eredivisie, title: "Eredivisie" },
    { id: 6, image: bundesligaStars, title: "Bundesliga" },
    { id: 7, image: premierLeague2526, title: "Premier League" },
    { id: 8, image: serieA2526, title: "Serie A" },
    { id: 9, image: euro2024Champions, title: "Euro 2024 Campeones" },
    { id: 10, image: laligaStars, title: "LaLiga" },
    { id: 11, image: championsLeagueTrophy, title: "Trofeo Champions League" },
    { id: 12, image: motogp, title: "MotoGP" },
    { id: 13, image: ufcPoster, title: "UFC" },
  ];

  const leaguesByName = {
    "Ligue 1": { image: leag1, name: "Ligue 1" },
    "Ligue 2": { image: leag2, name: "Ligue 2" },
    "F1": { image: leag12, name: "F1" },
    "UEFA Champions League": { image: leag3, name: "UEFA Champions League" },
    "Premier League": { image: leag4, name: "Premier League" },
    "La Liga": { image: leag5, name: "La Liga" },
    "Serie A": { image: leag6, name: "Serie A" },
    "Bundesliga": { image: leag7, name: "Bundesliga" },
    "Jupiler Pro League": { image: leag8, name: "Jupiler Pro League" },
    "UEFA Europa League": { image: leag9, name: "UEFA Europa League" },
    "Saudi League": { image: leag10, name: "Saudi League" },
    "UFC": { image: leag11, name: "UFC" },
    "Copa del Rey": { image: leag13, name: "Copa del Rey" },
  };
  const leagues = c.leagueOrder.map((name, i) => ({ id: i + 1, ...leaguesByName[name] }));

  return (
    <section className="section2" id="sports" style={{backgroundColor: 'var(--bg-color)'}}>
      <div className="main-content">
        <Reveal className="mb-10">
          <SectionHeading eyebrow={c.eyebrow} title={c.title} align="center" />
        </Reveal>

        {/* Carrusel de deportes — desplazamiento continuo */}
        <Reveal delay={100} className="mb-10">
          <Marquee
            items={sports}
            duration={42}
            renderItem={(item) => (
              <div className="group relative w-[150px] sm:w-[180px] md:w-[200px] lg:w-[220px] aspect-[2/3] rounded-card-md shadow-sm overflow-hidden border border-line">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              </div>
            )}
          />
        </Reveal>

        {/* Ligas disponibles — desplazamiento continuo */}
        <Reveal delay={150} className="mb-8">
          <Marquee
            items={leagues}
            direction="right"
            duration={34}
            renderItem={(lig) => {
              const isTightCrop = lig.name === "UFC" || lig.name === "F1";
              return (
                <div className="bg-white rounded-card-md border border-line px-6 py-4 shadow-sm w-40 sm:w-44 flex items-center justify-center h-16 md:h-20">
                  <img
                    src={lig.image}
                    alt={lig.name}
                    loading="lazy"
                    className={`max-w-full max-h-full object-contain opacity-90 ${isTightCrop ? "scale-75" : ""}`}
                  />
                </div>
              );
            }}
          />
        </Reveal>
      </div>
    </section>
  );
}
